/**
 * useDashboard — 创作者中心总览数据
 *
 * 仅在 enabled=true(已登录)时拉取。每个 days 改变都会重新拉。
 */
import { useCallback, useEffect, useState } from 'react'

import { ApiError, accountApi, type SilkDashboard } from '@/api'

interface State {
  data: SilkDashboard | null
  loading: boolean
  error: string | null
}

export function useDashboard(days = 30, enabled = true) {
  const [state, setState] = useState<State>({ data: null, loading: false, error: null })

  const refresh = useCallback(async () => {
    if (!enabled) return
    setState((s) => ({ ...s, loading: true, error: null }))
    try {
      const data = await accountApi.dashboard(days)
      setState({ data, loading: false, error: null })
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : (err as Error).message
      setState((s) => ({ ...s, loading: false, error: msg }))
    }
  }, [days, enabled])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { ...state, refresh }
}
